import {
  Flex,
  HStack,
  Spacer,
  Text,
  Heading,
  Box,
  Image,
} from "@chakra-ui/react";
import { Link as ScrollLink } from "react-scroll";
import React from "react";
import "../styles/navbar.css";

export default function Navbar() {
  return (
    <Flex bg="white" p={4} boxShadow="md">
      <Box flexDirection="row">
        <Flex flexDirection="row">
          <Image
            src="../2.jpg"
            alt="Ashraya PG"
            borderRadius="md"
            mb={4}
            w="50px"
            h="50px"
          />
          <Flex flexDirection="column">
            <Heading size="lg" className="name" color="blackAlpha.800">
              Ashraya Girl's PG
            </Heading>
            <a href="tel:+9198640 77200">
              <Heading size="sm" className="name" color="blackAlpha.800">
                +91 98640 77200
              </Heading>
            </a>
          </Flex>
        </Flex>
      </Box>
      <Spacer />
      <HStack spacing={8}>
        <Text fontSize="xl" className="cart">
          <ScrollLink to="home" smooth={true} duration={500}>
            HOME
          </ScrollLink>
        </Text>
        <Text fontSize="xl" className="cart">
          <ScrollLink to="about" smooth={true} duration={500}>
            ABOUT
          </ScrollLink>
        </Text>
      </HStack>
    </Flex>
  );
}
